/* eslint-disable no-undef */
window.Pocket = {
  eventListeners: {
    onGetTokenComplete: () => {
      throw new NotImplementedException('This method is not implemented.')
    },
    onGoBackComplete: () => {
      throw new NotImplementedException('This method is not implemented.')
    }
  },

  getToken (data, callback) {
    this.eventListeners.onGetTokenComplete = callback
    window.PocketMobile.postMessage(JSON.stringify({ action: 'getToken', data }))
  },

  goBack (data, callback) {
    this.eventListeners.onGoBackComplete = callback
    window.PocketMobile.postMessage(JSON.stringify({ action: 'getBack', data }))
  }

}
